import { type FC } from "react";

import { ColoredSequence } from "../../../blast-result/ColoredSequence.js";
import { SequenceType } from "../../../blast-result/SensorAlnInfoCard.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";

export const getVariantAlleleValue = (sequence: string) => {
  return (
    <span>
      {!sequence || sequence.includes(" ") ? (
        sequence
      ) : (
        <ColoredSequence offset={1} type={SequenceType.DNA} seq={sequence} />
      )}
    </span>
  );
};

const VariantAlleleCell: FC<IAgGridCellProps> = (props) => {
  const { value } = props;
  if (!value) {
    return null;
  }
  const multiValues = Array.isArray(value) ? value : [value];

  const items: ListCellItem[] = multiValues.map((sequence: string) => ({
    value: getVariantAlleleValue(sequence),
    tooltip: sequence,
  }));

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={props.context} />
    </TableCell>
  );
};

export default VariantAlleleCell;
